import { makeStyles } from "@mui/styles";
import Theme from "../../themes/theme";

export default makeStyles((theme: Theme) => {
  return {
    title: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: "31px",
      color: theme.palette.UI.grey_800,
    },
    subTitle: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "19px",
      color: theme.palette.UI.grey_800,
    },
    icon: {
      margin: 16,
      height: 200,
      width: 300,
    },
    dropdownSearchIcon: {
      height: 100,
      width: 260,
    },
    dropdownTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: theme.palette.UI.grey_800,
    },
    dropdownSubTitle: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.UI.grey_800,
      whiteSpace: "pre",
      marginBottom: 30,
      textAlign: "center",
    },
    modalDropdownSubTitle: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.UI.grey_800,
      whiteSpace: "normal",
      marginBottom: 30,
      textAlign: "center",
    },
  };
});
